// import React, { useState, useMemo } from "react";
// import Button from "components/ui/Button";

// const AllLeaveRequests = ({ leaves, handleStatusChange }) => {
//     console.log("Leaves data in AllLeaveRequests:", leaves);

//     const [selectedEmployeeLeaves, setSelectedEmployeeLeaves] = useState(null);
//     const [modalMonth, setModalMonth] = useState("");
//     // Flatten all leaves into a single list with employee + month
//     const allLeaves = useMemo(() => {
//         if (!leaves) return [];
//         return leaves.flatMap(empBlock =>
//             empBlock.leaves.map(leave => {
//                 const startDate = new Date(leave.start_date);
//                 return {
//                     ...leave,
//                     employee: empBlock.employee,
//                     year: startDate.getFullYear(),
//                     month: startDate.getMonth() + 1, // 1-based month
//                 };
//             })
//         );
//     }, [leaves]);

//     const [localLeaves, setLocalLeaves] = useState(allLeaves);

//     // Update status
//     const updateLeaveStatus = (leaveId, newStatus) => {
//         const updated = localLeaves.map(leave =>
//             leave.id === leaveId ? { ...leave, status: newStatus } : leave
//         );
//         setLocalLeaves(updated);
//         handleStatusChange(leaveId, newStatus);
//     };

//     // Filters
//     const [selectedEmployee, setSelectedEmployee] = useState("");
//     const [selectedMonth, setSelectedMonth] = useState("");
//     // const [selectedStatus, setSelectedStatus] = useState("");
//     // const [startDate, setStartDate] = useState("");
//     // const [endDate, setEndDate] = useState("");

//     // Unique employees for dropdown
//     const employeeIds = [...new Set(localLeaves.map(l => l.employee?.employee_id))];

//     // Apply filters
//     const filteredLeaves = useMemo(() => {
//         return localLeaves.filter(leave => {
//             const matchesEmployee =
//                 !selectedEmployee || leave.employee?.employee_id === selectedEmployee;

//             const matchesMonth =
//                 !selectedMonth || leave.month === parseInt(selectedMonth);

//             // const matchesStatus =
//             //     !selectedStatus || leave.status.toLowerCase() === selectedStatus.toLowerCase();

//             // const leaveStart = new Date(leave.start_date);
//             // const matchesDateRange =
//             //     (!startDate || leaveStart >= new Date(startDate)) &&
//             //     (!endDate || leaveStart <= new Date(endDate));

//             // return matchesEmployee && matchesMonth && matchesStatus && matchesDateRange;
//             return matchesEmployee && matchesMonth
//         });
//         // }, [localLeaves, selectedEmployee, selectedMonth, selectedStatus, startDate, endDate]);
//     }, [localLeaves, selectedEmployee, selectedMonth]);

//     // Group by employee + month
//     const groupedData = useMemo(() => {
//         return filteredLeaves.reduce((acc, leave) => {
//             const key = `${leave.employee.employee_id}-${leave.year}-${leave.month}`;
//             if (!acc[key]) {
//                 acc[key] = {
//                     employee: leave.employee,
//                     year: leave.year,
//                     month: leave.month,
//                     total_leaves: 0,
//                     total_lop: 0,
//                     allLeaves: [],
//                 };
//             }
//             acc[key].total_leaves += leave.total_days || 0;
//             acc[key].total_lop += leave.lop_days || 0;
//             acc[key].allLeaves.push(leave);
//             return acc;
//         }, {});
//     }, [filteredLeaves]);

//     const monthlyList = Object.values(groupedData);

//     return (
//         <>
//             {/* Filters */}
//             <div className="bg-white shadow-md rounded-xl p-4 mb-6">
//                 <h3 className="text-md font-semibold mb-4">🔍 Filters</h3>
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
//                     <select
//                         className="border px-3 py-2 rounded-lg shadow-sm"
//                         value={selectedEmployee}
//                         onChange={(e) => setSelectedEmployee(e.target.value)}
//                     >
//                         <option value="">All Employees</option>
//                         {employeeIds.map((emp) => (
//                             <option key={emp} value={emp}>
//                                 {emp}
//                             </option>
//                         ))}
//                     </select>

//                     <select
//                         className="border px-3 py-2 rounded-lg shadow-sm"
//                         value={selectedMonth}
//                         onChange={(e) => setSelectedMonth(e.target.value)}
//                     >
//                         <option value="">All Months</option>
//                         {[...Array(12).keys()].map((m) => (
//                             <option key={m + 1} value={m + 1}>
//                                 {new Date(0, m).toLocaleString("default", { month: "long" })}
//                             </option>
//                         ))}
//                     </select>

//                     {/* <select
//                         className="border px-3 py-2 rounded-lg shadow-sm"
//                         value={selectedStatus}
//                         onChange={(e) => setSelectedStatus(e.target.value)}
//                     >
//                         <option value="">All Status</option>
//                         <option value="pending">Pending</option>
//                         <option value="approved">Approved</option>
//                         <option value="rejected">Rejected</option>
//                     </select>

//                     <input
//                         type="date"
//                         className="border px-3 py-2 rounded-lg shadow-sm"
//                         value={startDate}
//                         onChange={(e) => setStartDate(e.target.value)}
//                     />

//                     <input
//                         type="date"
//                         className="border px-3 py-2 rounded-lg shadow-sm"
//                         value={endDate}
//                         onChange={(e) => setEndDate(e.target.value)}
//                     /> */}
//                 </div>

//                 <div className="flex justify-end mt-4">
//                     <Button
//                         className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg"
//                         onClick={() => {
//                             setSelectedEmployee("");
//                             setSelectedMonth("");
//                             // setSelectedStatus("");
//                             // setStartDate("");
//                             // setEndDate("");
//                         }}
//                     >
//                         Reset
//                     </Button>
//                 </div>
//             </div>

//             {/* Monthly Summary */}
//             <div className="bg-white shadow-md rounded-xl p-6">
//                 <h2 className="text-lg font-semibold mb-4">Monthly Leave Summary</h2>
//                 <div className="overflow-x-auto">
//                     <table className="w-full border">
//                         <thead className="bg-muted">
//                             <tr>
//                                 <th className="p-3 text-left">Employee ID</th>
//                                 <th className="p-3 text-left">Name</th>
//                                 <th className="p-3 text-left">Month</th>
//                                 <th className="p-3 text-left">Total Leaves</th>
//                                 <th className="p-3 text-left">Total LOP</th>
//                                 <th className="p-3 text-left">Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {monthlyList.map((item) => {
//                                 const rowKey = `${item.employee.employee_id}-${item.year}-${item.month}`;
//                                 return (
//                                     <React.Fragment key={rowKey}>
//                                         <tr className="border-b hover:bg-gray-50">
//                                             <td className="p-3">{item.employee.employee_id}</td>
//                                             <td className="p-3">
//                                                 {item.employee.first_name} {item.employee.last_name}
//                                             </td>
//                                             <td className="p-3">
//                                                 {new Date(item.year, item.month - 1).toLocaleString("default", {
//                                                     month: "long",
//                                                     year: "numeric",
//                                                 })}
//                                             </td>
//                                             <td className="p-3">{item.total_leaves}</td>
//                                             <td className="p-3">{item.total_lop}</td>
//                                             <td className="p-3">
//                                                 <Button
//                                                     className="bg-primary text-white px-3 py-1 rounded"
//                                                     onClick={() => {
//                                                         setSelectedEmployeeLeaves(item.allLeaves);
//                                                         setModalMonth(item.month); // default filter
//                                                     }}
//                                                 >
//                                                     Details
//                                                 </Button>
//                                             </td>
//                                         </tr>


//                                     </React.Fragment>
//                                 );
//                             })}
//                         </tbody>
//                     </table>
//                     {selectedEmployeeLeaves && (
//                         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//                             <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-4xl p-6">
//                                 <h3 className="text-lg font-semibold mb-4">
//                                     Leave Details – {selectedEmployeeLeaves[0]?.employee?.first_name}{" "}
//                                     {selectedEmployeeLeaves[0]?.employee?.last_name}
//                                 </h3>

//                                 {/* Month Filter */}
//                                 <select
//                                     className="border px-3 py-2 rounded-lg mb-4"
//                                     value={modalMonth}
//                                     onChange={(e) => setModalMonth(parseInt(e.target.value))}
//                                 >
//                                     <option value="">All Months</option>
//                                     {[...Array(12).keys()].map((m) => (
//                                         <option key={m + 1} value={m + 1}>
//                                             {new Date(0, m).toLocaleString("default", { month: "long" })}
//                                         </option>
//                                     ))}
//                                 </select>

//                                 <table className="w-full text-sm border">
//                                     <thead className="bg-gray-200">
//                                         <tr>
//                                             <th className="p-2">Type</th>
//                                             <th className="p-2">Start</th>
//                                             <th className="p-2">End</th>
//                                             <th className="p-2">Days</th>
//                                             <th className="p-2">Paid</th>
//                                             <th className="p-2">LOP</th>
//                                             <th className="p-2">Reason</th>
//                                             <th className="p-2">Status</th>
//                                             <th className="p-2">Actions</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {selectedEmployeeLeaves
//                                             .filter((leave) => !modalMonth || leave.month === modalMonth)
//                                             .map((leave) => (
//                                                 <tr key={leave.id} className="border-b">
//                                                     <td className="p-2">{leave.leave_type}</td>
//                                                     <td className="p-2">{leave.start_date}</td>
//                                                     <td className="p-2">{leave.end_date}</td>
//                                                     <td className="p-2">{leave.total_days}</td>
//                                                     <td className="p-2">{leave.paid_days}</td>
//                                                     <td className="p-2">{leave.lop_days}</td>
//                                                     <td className="p-2">{leave.reason || "-"}</td>
//                                                     <td className="p-2">{leave.status}</td>
//                                                     <td className="p-2 space-x-2">
//                                                         {leave.status === "pending" && (
//                                                             <>

//                                                                 <Button
//                                                                     className="bg-green-500 text-white px-2 py-1 rounded"
//                                                                     onClick={() =>
//                                                                         updateLeaveStatus(
//                                                                             leave.id,
//                                                                             "approved"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     Approve
//                                                                 </Button>
//                                                                 <Button
//                                                                     className="bg-red-500 text-white px-2 py-1 rounded"
//                                                                     onClick={() =>
//                                                                         updateLeaveStatus(
//                                                                             leave.id,
//                                                                             "rejected"
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     Reject
//                                                                 </Button>
//                                                             </>
//                                                         )}
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                     </tbody>
//                                 </table>

//                                 <div className="flex justify-end mt-4">
//                                     <Button
//                                         className="bg-gray-500 text-white px-4 py-2 rounded"
//                                         onClick={() => setSelectedEmployeeLeaves(null)}
//                                     >
//                                         Close
//                                     </Button>
//                                 </div>
//                             </div>
//                         </div>
//                     )}

//                 </div>
//             </div>
//         </>
//     );
// };

// export default AllLeaveRequests;

import React, { useState, useMemo } from "react";
import Button from "components/ui/button";
import Modal from "components/ui/modal";

const AllLeaveRequests = ({ leaves, handleStatusChange }) => {
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);

    // Flatten leaves with year/month
    const allLeaves = useMemo(() => {
        if (!leaves) return [];
        return leaves.flatMap((empBlock) =>
            empBlock.leaves.map((leave) => {
                const startDate = new Date(leave.start_date);
                return {
                    ...leave,
                    employee: empBlock.employee,
                    year: startDate.getFullYear(),
                    month: startDate.getMonth() + 1,
                    monthly_quota: empBlock.monthly_quota,
                    remaining_paid_leave_this_month: empBlock.remaining_paid_leave_this_month,
                    used_this_month: empBlock.used_this_month,
                };
            })
        );
    }, [leaves]);

    // Group by employee
    const employeeGrouped = useMemo(() => {
        return allLeaves.reduce((acc, leave) => {
            const empId = leave.employee.employee_id;
            if (!acc[empId]) {
                acc[empId] = {
                    employee: leave.employee,
                    months: {},
                };
            }
            const key = `${leave.year}-${leave.month}`;
            if (!acc[empId].months[key]) {
                acc[empId].months[key] = {
                    year: leave.year,
                    month: leave.month,
                    monthly_quota: leave.monthly_quota,
                    remaining_paid_leave_this_month: leave.remaining_paid_leave_this_month,
                    used_this_month: leave.used_this_month,
                    total_leaves: 0,
                    total_paid: 0,
                    total_lop: 0,
                    allLeaves: [],
                };
            }
            acc[empId].months[key].total_leaves += leave.total_days || 0;
            acc[empId].months[key].total_paid += leave.paid_days || 0;
            acc[empId].months[key].total_lop += leave.lop_days || 0;
            acc[empId].months[key].allLeaves.push(leave);
            return acc;
        }, {});
    }, [allLeaves]);

    const employeeList = Object.values(employeeGrouped);

    const updateLeaveStatus = (leaveId, newStatus) => {
        handleStatusChange(leaveId, newStatus);
    };

    const openEmployeeModal = (emp) => {
        setSelectedEmployee(emp);
        const now = new Date();
        setSelectedMonth(now.getMonth() + 1); // default current month
    };

    return (
        <>
            {/* Employee Summary Table */}
            <div className="bg-white shadow-md rounded-xl p-6 mb-6">
                <h2 className="text-lg font-semibold mb-4">Employees Leave Summary</h2>
                <div className="overflow-x-auto">
                    <table className="w-full border">
                        <thead className="bg-muted">
                            <tr>
                                <th className="p-3 text-left">Employee ID</th>
                                <th className="p-3 text-left">Name</th>
                                <th className="p-3 text-left">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {employeeList.map((emp) => (
                                <tr key={emp.employee.employee_id} className="border-b hover:bg-gray-50">
                                    <td className="p-3">{emp.employee.employee_id}</td>
                                    <td className="p-3">{emp.employee.first_name} {emp.employee.last_name}</td>
                                    <td className="p-3">
                                        <Button
                                            className="bg-primary text-white px-3 py-1 rounded"
                                            onClick={() => openEmployeeModal(emp)}
                                        >
                                            Details
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Employee Leave Modal */}
            {selectedEmployee && (
                <Modal isOpen={selectedEmployee} onClose={() => setSelectedEmployee(null)}>
                    <div className="p-4">
                        <h1 className="text-lg font-semibold border-b py-4 mb-4">
                            Leave Details – {selectedEmployee.employee.first_name} {selectedEmployee.employee.last_name}
                        </h1>

                        {/* Month Selector */}
                        <select
                            className="border px-3 py-2 rounded-lg mb-4"
                            value={selectedMonth || ""}
                            onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
                        >
                            {Object.values(selectedEmployee.months)
                                .sort((a, b) => a.year * 12 + a.month - (b.year * 12 + b.month))
                                .map((m) => (
                                    <option key={`${m.year}-${m.month}`} value={m.month}>
                                        {new Date(m.year, m.month - 1).toLocaleString("default", { month: "long", year: "numeric" })}
                                    </option>
                                ))}
                        </select>

                        {/* Month-wise Leave Table */}
                        {(() => {
                            const monthBlocks = Object.values(selectedEmployee.months).filter(
                                (monthBlock) => monthBlock.month === selectedMonth
                            );

                            if (!monthBlocks.length) {
                                return <p className="text-center text-gray-500 mt-4">No data available for this month.</p>;
                            }

                            return monthBlocks.map((monthBlock) => (
                                <div key={`${monthBlock.year}-${monthBlock.month}`} className="mb-6 border rounded-lg p-4">
                                    <h4 className="font-semibold mb-2">
                                        {new Date(monthBlock.year, monthBlock.month - 1).toLocaleString("default", { month: "long", year: "numeric" })}
                                        {" "}– Total: {monthBlock.total_leaves} | Paid: {monthBlock.total_paid} | LOP: {monthBlock.total_lop} | Remaining: {monthBlock.remaining_paid_leave_this_month}
                                    </h4>

                                    <table className="w-full text-sm border">
                                        <thead className="bg-gray-200">
                                            <tr>
                                                <th className="p-2">Type</th>
                                                <th className="p-2">Start</th>
                                                <th className="p-2">End</th>
                                                <th className="p-2">Days</th>
                                                <th className="p-2">Paid</th>
                                                <th className="p-2">LOP</th>
                                                <th className="p-2">Reason</th>
                                                <th className="p-2">Status</th>
                                                <th className="p-2">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {monthBlock.allLeaves.map((leave) => (
                                                <tr key={leave.id} className="border-b">
                                                    <td className="p-2">{leave.leave_type}</td>
                                                    <td className="p-2">{leave.start_date}</td>
                                                    <td className="p-2">{leave.end_date}</td>
                                                    <td className="p-2">{leave.total_days}</td>
                                                    <td className="p-2">{leave.paid_days}</td>
                                                    <td className="p-2">{leave.lop_days}</td>
                                                    <td className="p-2">{leave.reason || "-"}</td>
                                                    <td className="p-2">{leave.status}</td>
                                                    <td className="p-2 space-x-2">
                                                        {leave.status === "pending" && (
                                                            <>
                                                                <Button
                                                                    className="bg-green-500 text-white px-2 py-1 rounded"
                                                                    onClick={() => updateLeaveStatus(leave.id, "approved")}
                                                                >
                                                                    Approve
                                                                </Button>
                                                                <Button
                                                                    className="bg-red-500 text-white px-2 py-1 rounded"
                                                                    onClick={() => updateLeaveStatus(leave.id, "rejected")}
                                                                >
                                                                    Reject
                                                                </Button>
                                                            </>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ));
                        })()}

                        <div className="flex justify-end mt-4">
                            <Button
                                className="bg-gray-500 text-white px-4 py-2 rounded"
                                onClick={() => setSelectedEmployee(null)}
                            >
                                Close
                            </Button>
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
};

export default AllLeaveRequests;
